import { render } from "./WoundPanelSelectedTests.vue?vue&type=template&id=77f15eab"
import script from "./WoundPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./WoundPanelSelectedTests.vue?vue&type=script&lang=js"

import "./WoundPanelSelectedTests.vue?vue&type=style&index=0&id=77f15eab&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/WoundPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77f15eab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77f15eab', __exports__)) {
    console.log('reload')
    api.reload('77f15eab', __exports__)
  }
  
  module.hot.accept("./WoundPanelSelectedTests.vue?vue&type=template&id=77f15eab", () => {
    console.log('re-render')
    api.rerender('77f15eab', render)
  })

}


export default __exports__